import { combineReducers } from 'redux'

import { securityUsersReducer } from './users'
import { securityGroupsReducer } from './groups'
import { securityIPAccessesReducer } from './ipAccesses'
import { firewallReducer } from './firewall'
import { ipAddressReducer } from './ipAddress'

export const securityReducer = combineReducers({
  users: securityUsersReducer,
  groups: securityGroupsReducer,
  ipAccesses: securityIPAccessesReducer,
  firewall: firewallReducer,
  ipAddress: ipAddressReducer,
})
